export default "__VITE_ASSET__o_5rljUC__"